/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import classes from '@/app/components/common/Categories/styles.module.scss';
import {deviceDetection} from "@/app/utils/deviceDetection";
import Image from "next/image";
import React from "react";
import Carousel from "react-multi-carousel";
import stylesConfig from "/styles/configs/index.module.scss";
import {isServerSideRendering} from "@/app/utils/common";
import {Button} from "@mui/material";
import LazyLoad from "@/app/components/LazyLoad";

const Categories = (props: {
    categories: {
        name: string,
        image?: string|null,
        url?: string|null|undefined
    }[],
    
    id?: string,
    className?: string,
    variation?: string,
    
}) => {
    const {mobile, tablet, desktop, currentDevice:currentDeviceDetected} = deviceDetection();
    
    // Using mobile version of slider for server side rendering to resolve performance issues
    const currentDevice = isServerSideRendering() ? 'mobile' : currentDeviceDetected;

    const carouselPlaceholder = `/assets/common/category-placeholder-bg.png`;

    const sliderSettings = {
        ssr: true,
        deviceType: currentDevice, // device for server side rendering (mobile, tablet, desktop)
        infinite: true,
        autoPlay: false,
        autoPlaySpeed: 6000,
        swipeable: true,
        draggable: true,
        showDots: false,
        keyBoardControl: true,
        dotListClass: classes.dots,
        responsive: {
            desktop: {
                breakpoint: { max: 4000, min: parseInt(stylesConfig.breakpointUpXL) },
                items: 5,
                slidesToSlide: 1,
            },
            large: {
                breakpoint: { max:1392, min: 1200 },
                items: 4,
                slidesToSlide: 1,
            },
            tablet: {
                breakpoint: { max: parseInt(stylesConfig.breakpointDownXL), min: parseInt(stylesConfig.breakpointUpM) },
                items: 3,
                slidesToSlide: 1,
            },
            medium: {
                breakpoint: { max:767, min: 600 },
                items: 2,
                slidesToSlide: 1,
            },
            mobile: {
                breakpoint: { max: 599, min: 0 },
                items: 1,
                slidesToSlide: 1,
            }
        },
    };

    return props.categories?.length > 0 ? <div className={classes.categoryCarouselWrapper}>
        <LazyLoad className={classes.categoryCarousel} shiftBeforeLoad={100}>
        {props.categories && props.categories.length > 0 && <Carousel {...sliderSettings}>
            {props.categories?.map(
                (category, index) => {
                    return <div key={`${index} - ${category.name}`} className={classes.categoryCarouselItem}>
                        <Image
                            src={category.image ? `https://${category.image}` : carouselPlaceholder}
                            alt={category.name}
                            width={239}
                            height={239}
                            className={classes.categoryImage}
                        />

                        <p className={classes.categoryName}>{category.name}</p>

                        <Button variant={'primary'} href={category.url ? category.url : '#'}
                                className={`${classes['view-all-btn']}`}>{('View All')}
                        </Button>
                    </div>
                }
            )}
        </Carousel>}
    </LazyLoad>
    </div> : <></>
}

export default Categories;